import actions from './actions'
import {
  getDefaultPricing,
  inputPricingOptions,
  validationLimits
} from './constants'
import getters from './getters'
import * as types from './types'

const state = {
  partner: {},
  pricing: getDefaultPricing(),
  pricingToBeSaved: getDefaultPricing(),
  paymentTermUnitOptions: inputPricingOptions.paymentTermUnitOptions,
  repaymentMethodOptions: inputPricingOptions.repaymentMethodOptions,
  repaymentInterestMethodOptions:
    inputPricingOptions.repaymentInterestMethodOptions,
  billingUnitOptions: inputPricingOptions.billingUnitOptions,
  infoDialog: {
    isOpen: false,
    title: '',
    key: ''
  },
  isEditMode: false,
  isConfigNotFound: false,
  validationLimits,
  partnerDetails: {},
  partnerBankAccounts: [],
  updatedPartner: {}
}

const mutations = {
  [types.SET_PARTNER]: function (state, newPartner) {
    state.partner = newPartner
  },
  [types.SET_INFO_DIALOG]: function (state, dialogValue) {
    state.infoDialog = dialogValue
  },
  [types.SET_IS_EDIT_MODE]: function (state, turn) {
    state.isEditMode = turn
  },
  [types.SET_IS_CONFIG_NOT_FOUND]: function (state, newValue) {
    state.isConfigNotFound = newValue
  },
  [types.SET_PARTNER_INFO]: function (state, value) {
    state.partnerDetails = value
  },
  [types.SET_PARTNER_BANK_ACCOUNTS]: function (state, value) {
    state.partnerBankAccounts = value
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
